module.exports = __webpack_public_path__ + "img/img-1.fd265a30.png";